<template>
  <div id="app">
    <component :is="layout" :class="layout">
      <router-view></router-view>
    </component>
  </div>
</template>
<script>
window.commonData = {
  isPublice: false,
};
export default {
  computed: {
    getMobile() {
      var flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag === null) {
        return false;
      } else {
        return true;
      }
    },
    layout() {
      let meta = this.getMobile;
      let layout = meta ? "mobile" : "pc";
      return layout;
    },
  },
};
</script>

<style lang="less">
@import "~@/assets/todoCenter/default/css/main.less";
</style>



// WEBPACK FOOTER //
// src/App.vue